<template>
<div>
    <div class="grid-x">
        <div class="form__item cell">
          {{labels.publishedInJournal}}*
            <label class="label--checkbox label--inline">
              <input type="radio" @change="update(true)" :value="true" v-model="published" :disabled="!editable">
              {{labels.yes}}
            </label>
            &nbsp;
            <label class="label--checkbox label--inline">
              <input type="radio" @change="update(true)" :value="false" v-model="published" :disabled="!editable">
              {{labels.no}}
            </label>
        </div>
        <div class="form__item large-8 cell" v-show="published">
              <vue-simple-suggest
                v-if="journals"
                v-show="!useList"
                v-model="selectedJournal"
                :list="journals"
                display-attribute="name"
                :max-suggestions="0"
                :filter-by-query="true"
                @select="update(false)"
                :debounce="200"
                mode="select"
                ref="journalSelect"
                :remove-list="false"
                :prevent-submit="true"
                @focus="focus"
              >
                  <input @keyup="update(false)" :placeholder="'Søg efter tidsskrift*'" type="text" :disabled="!editable">
                  <div
                      slot="suggestion-item"
                      slot-scope="{ suggestion, autocomplete }"
                      :class="{ 'is-popular': suggestion.popular }"
                  >
                        <span>{{ suggestion.name }}</span>
                  </div>
              </vue-simple-suggest>{{labels.searchForJournal}}
              <label
                for="useList"
                class="label--checkbox label--inline"
              >
                <input type="checkbox" id="useList" v-model="useList" @change="update(true)" :disabled="!editable">
                {{labels.searchForJournalNotInList}}
              </label>
        </div>
        <div class="form__item form__item--single large-6 cell" v-if="(useList && published) || published === false">
              <input
                type="text"
                id="place"
                v-model="place"
                @keyup="update(false)"
                v-floatable :disabled="!editable"
              >
              <label for="place" class="floating-label">{{labels.placeOfPublicationOrJournal}}</label>
        </div>
    </div>
    <div class="grid-x">
        <div class="form__item form__item--single large-6 cell" v-if="published !== undefined">
            <textarea rows="6" name="comment" id="comment" v-model="comment" @change="update(false)" :disabled="!editable" v-floatable maxlength="1500"></textarea>
            <label for="comment" class="floating-label">{{labels.comment}}  <small>{{labels.pagesVersionAndMore}}</small></label>
        </div>
    </div>
  </div>
</template>

<script>
//import VueSimpleSuggest from 'vue-simple-suggest/lib'
import VueSimpleSuggest from "vue-simple-suggest/dist/cjs"; //todo: use this to build commonjs style!
import { find } from "lodash";

export default {
  props: ["publishedInScientificJournal", "editable", "publicationPlace", "publicationComment", "scientificJournalId", "labels"],
  components: {
    VueSimpleSuggest
  },
  data() {
    return {
      selectedJournal: null,
      useList: false,
      published: this.publishedInScientificJournal,
      place: this.publicationPlace,
      comment: this.publicationComment,
      journalId: this.scientificJournalId
    };
  },
  computed: {
    journals() {
      return this.$store.state.journals;
    },
    valid() {
      var _valid = true;
      if (this.published === false) {
        _valid = true;
      } else if(this.published === true) {
        _valid = (this.journalId !== null) || (useList && this.place.trim() !== "");
      } else {
          _valid = false;
      }
      return _valid;
    },
    labels() {
        return this.$store.state.labels["pages.mypage.suggestStudy"] || {};
    },
  },
  mounted() {
    this.$store.dispatch('getLabels', { label: 'pages.mypage.suggestStudy' });
    this.$store.dispatch("getJournals").then(list => {
        var item;

        if (this.scientificJournalId !== null){
            item = find(this.journals, { id: this.scientificJournalId });
        }
            if (item !== undefined) {
                this.journalId = this.scientificJournalId
                this.published = true;
                this.$refs.journalSelect.select(item);
                this.selectedJournal = item;
            } else {
                this.useList = (!this.editable && (this.scientificJournalId === null || this.scientificJournalId === undefined)); 
                this.useList = (this.scientificJournalId === null || this.scientificJournalId === undefined) && this.published && this.place; 
            }
        
        setTimeout(()=> this.update(false), 500)
    });
  },
  methods: {
    update(clear) {
        if(clear){
            this.clear();
        }
        this.journalId = typeof this.selectedJournal === "object" && this.selectedJournal !== null ? this.selectedJournal.id : null;
        this.$emit("update", {
            journalId: this.journalId,
            comment: this.comment,
            place: this.place,
            published: this.published,
            error: !this.valid
        });
    },
    focus(e) {
      e.target.select();
      this.$refs.journalSelect.showList();
    },
    clear() {
        this.selectedJournal = null;
        this.$refs.journalSelect.select("");
        this.place = "";
    }
  }
};
</script>

<style lang="scss">
.head__content {
  padding-bottom: rem-calc(40);
}

.vue-simple-suggest.designed {
  position: relative;
}

.vue-simple-suggest.designed,
.vue-simple-suggest.designed * {
  box-sizing: border-box;
}

.vue-simple-suggest.designed .input-wrapper input {
  display: block;
  width: 100%;
  padding: 10px;
  border: 1px solid #cde;
  border-radius: 3px;
  color: black;
  background: white;
  outline: none;
  transition: all 0.1s;
  transition-delay: 0.05s;
}

.vue-simple-suggest.designed.focus .input-wrapper input {
  border: 1px solid #aaa;
}

.vue-simple-suggest.designed .suggestions {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  top: calc(100% + 5px);
  border-radius: 3px;
  border: 1px solid #aaa;
  background-color: #fff;
  opacity: 1;
  z-index: 1000;
}

.vue-simple-suggest.designed .suggestions .suggest-item {
  cursor: pointer;
  user-select: none;
}

.vue-simple-suggest.designed .suggestions .suggest-item,
.vue-simple-suggest.designed .suggestions .misc-item {
  padding: 5px 10px;
}

.vue-simple-suggest.designed .suggestions .suggest-item.hover {
  background-color: #2874d5 !important;
  color: #fff !important;
}

.vue-simple-suggest.designed .suggestions .suggest-item.selected {
  background-color: #2832d5;
  color: #fff;
}

.suggestions {
  max-height: 500px;
  overflow-y: auto;
  margin-top: 0;
}

.suggest-item {
  text-align: left;
  color: black;

  span {
    font-weight: 400;
  }
}

body .vue-simple-suggest.designed .suggestions {
  top: 44px;
}

body .vue-simple-suggest.designed .suggestions .suggest-item.hover {
  background-color: $blue !important;
}

.suggest-item > .is-popular span {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/JournalsAutocomplete.vue